(() => {
  const LOCK_CLASS = "cookie-scroll-locked";
  const BANNER_SEL = "#shopify-pc__banner";
  const PREFS_SEL  = "#shopify-pc__prefs";


  // ✅ Shopify Theme-Editor: niemals locken / overlayn
  if (window.Shopify && Shopify.designMode) {
    document.documentElement.classList.remove(LOCK_CLASS);
    document.body.classList.remove(LOCK_CLASS);
    document.body.style.top = "";
    return; // Script hier beenden
  }










  let scrollY = 0;

  const lock = () => {
    if (document.documentElement.classList.contains(LOCK_CLASS)) return;
    scrollY = window.scrollY || 0;
    document.documentElement.classList.add(LOCK_CLASS);
    document.body.classList.add(LOCK_CLASS);
    document.body.style.top = `-${scrollY}px`; // für iOS fix
  };

  const unlock = () => {
    if (!document.documentElement.classList.contains(LOCK_CLASS)) return;
    document.documentElement.classList.remove(LOCK_CLASS);
    document.body.classList.remove(LOCK_CLASS);
    const top = document.body.style.top;
    document.body.style.top = "";
    // scroll position zurücksetzen
    const y = top ? Math.abs(parseInt(top, 10)) : scrollY;
    window.scrollTo(0, y || 0);
  };

  const isVisible = (el) => {
    if (!el) return false;
    const s = getComputedStyle(el);
    return s.display !== "none" && s.visibility !== "hidden" && el.offsetHeight > 0;
  };

  const bannerVisible = () => isVisible(document.querySelector(BANNER_SEL)) || isVisible(document.querySelector(PREFS_SEL));

  // Consent bereits entschieden?
  const consentDecided = () => {
    try {
      const cp = window.Shopify?.customerPrivacy;
      if (!cp?.currentVisitorConsent) return false;
      const c = cp.currentVisitorConsent();
      // Wenn irgendeine Kategorie einen Wert hat, wurde interagiert
      return ["analytics", "marketing", "preferences"].some(k => c?.[k] && c[k] !== "");
    } catch {
      return false;
    }
  };

  const sync = () => {
    // Priorität: Wenn Banner sichtbar -> lock
    if (bannerVisible()) return lock();

    // Wenn Consent schon entschieden -> unlock
    if (consentDecided()) return unlock();

    // Wenn Shopify sagt "Banner sollte gezeigt werden", lock (auch wenn es gleich erst injiziert wird)
    try {
      const cp = window.Shopify?.customerPrivacy;
      if (cp?.shouldShowBanner?.()) return lock();
    } catch {}

    // sonst unlock
    unlock();
  };

  // 1) direkt beim Start versuchen
  sync();

  // 2) Banner wird oft nachträglich in den DOM injiziert -> beobachten
  const mo = new MutationObserver(sync);
  mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true });

  // 3) Shopify feuert dieses Event nach Accept/Decline -> entsperren
  document.addEventListener("visitorConsentCollected", unlock);

  // 4) Extra: in den ersten Sekunden pollt es häufiger (sehr zuverlässig)
  let n = 0;
  const iv = setInterval(() => {
    sync();
    n += 1;
    if (n > 40) clearInterval(iv); // ~10 Sekunden
  }, 250);
})();
